import React, { useEffect, useState } from "react";

import { Button, Result } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const WalletPaymentRedirect = () => {
  const [countdown, setCountdown] = useState<number>(3);

  useEffect(() => {
    const timer =
      countdown > 0 &&
      setInterval(() => {
        setCountdown((prev: any) => prev - 1);
      }, 1000);

    if (countdown === 0) {
      window.close();
    }
    return () => {
      clearInterval(timer as NodeJS.Timeout);
    };
  }, [countdown]);

  // Pending
  return (
    <Result
      icon={<LoadingOutlined style={{ color: "#ef4343" }} />}
      title="Đang chuyển tiếp về trang thanh toán..."
      // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
      extra={[
        <Button type="primary" key="continue">
          {countdown} Đóng
        </Button>,
      ]}
      style={{
        background: "#ffffff",
        borderRadius: "3px",
        margin: "10px",
        height: "calc(100vh - 161px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    />
  );
};

export default WalletPaymentRedirect;
